import styled from 'styled-components';
export const StyledAppMenuModal = styled.div`
  z-index: 200;
  position: absolute;
  background-color: ${({ theme }) => theme.backgroundDark};
  top: 100%;
  right: ${({ theme }) => theme.frameOffset};
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  width: ${({ theme }) => theme.hudPanelWidth};
  min-width: 18.75rem;
  max-width: ${({ theme }) => theme.hudPanelMaxWidth};
  min-height: 620px;
  height: calc(100vh - ${({ theme }) => theme.frameOffset} - ${({ theme }) => theme.navHeight});
  animation: popup-animation-translate 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0s 1 normal forwards, popup-animation-opacity 0.1s cubic-bezier(0.5, 0.35, 0, 1) 0s 1 normal forwards;

  .menu-contents {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .menu-background {
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.background};
  }

  .menu-main-container {
    margin: 24px 0;
    width: 100%;
  }

  .menu-secondary-container {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .menu-logo {
    width: ${({ theme }) => theme.selectableButtonSize};
    height: ${({ theme }) => theme.selectableButtonSize};
    position: absolute;
    bottom: 24px;
    right: 16px;
  }

  .menu-corner {
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    border: solid ${({ theme }) => theme.frameWidth} white;
    position: absolute;
    animation: corner-scale 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards;
  }

  .menu-corner-tl {
    border-right: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    left: 0;
  }

  .menu-decorator {
    border-right: solid 2px ${({ theme }) => theme.borderDark};
    border-left: solid 2px ${({ theme }) => theme.borderDark};
    background: ${({ theme }) => theme.selection};
    height: ${({ theme }) => theme.frameWidth};
    width: ${({ theme }) => theme.selectableButtonSize};
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    position: absolute;
    top: 0;
    right: 0;
  }

  .menu-corner-br {
    border-left: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    right: 0;
  }

  .menu-corner-bl {
    border-right: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    left: 0;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    height: calc(100vh - 3.75rem - ${({ theme }) => theme.frameOffset});
    width: calc(100vw - 2 * ${({ theme }) => theme.frameOffset});
    max-width: unset;
    min-width: unset;
    right: ${({ theme }) => theme.frameOffset};
    left: ${({ theme }) => theme.frameOffset};
  }
`;
